import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import wlcBtnNext from "./components/wlc-btn-next.vue";
import { mapActions } from "vuex";
import dayjs from "dayjs";
import { appendUrlParam } from '@/utils/url';
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
var perceptionCode = {
  PHiuUt: "诈骗",
  orTPeJ: "中介/二房东"
};
export default {
  mixins: [userPopMixin],
  components: {
    wlcBtnNext: wlcBtnNext
  },
  name: "lifestyle-update",
  data: function data() {
    return {
      videoVisible: false,
      btnNextVisible: false,
      form: {
        imgs: [],
        cover: "",
        location: "",
        title: "",
        content: "",
        tag: [],
        video: "",
        append_views_num: '',
        append_collect_num: ''
      },
      userForm: {},
      previewDialogVisible: false,
      imageRotateDialogVisible: false,
      imageRotateUrl: "",
      imageRotateKey: "",
      userTag: [],
      deviceRisk: {},
      addDataList: [{
        views_num: 19,
        collect_num: 0
      }, {
        views_num: 39,
        collect_num: 1
      }, {
        views_num: 79,
        collect_num: 2
      }, {
        views_num: 99,
        collect_num: 3
      }],
      tagList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getLifestyleTagList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  computed: {
    getPerceptionCodeName: function getPerceptionCodeName() {
      return perceptionCode[this.deviceRisk.perception_code] ? perceptionCode[this.deviceRisk.perception_code] : "";
    }
  },
  watch: {
    "$route.query.id": function $routeQueryId() {
      this.userTag = [];
      this.loading = true;
      this.getData();
      this.btnNextVisible = false;
      this.releaseCompleteState = false;
      var containerBody = document.getElementsByClassName("d2-container-full__body")[0];
      containerBody.scrollTop = 0;
    },
    previewDialogVisible: function previewDialogVisible() {
      var _this2 = this;
      this.$nextTick(function () {
        if (_this2.previewDialogVisible) {
          document.addEventListener('keydown', _this2.keydownEventHandle);
        } else {
          document.removeEventListener('keydown', _this2.keydownEventHandle);
        }
      });
    },
    "form.append_views_num": function formAppend_views_num() {
      var _this3 = this;
      this.addDataList.forEach(function (item) {
        if (item.views_num == _this3.form.append_views_num) {
          _this3.form.append_collect_num = item.collect_num;
        }
      });
    },
    "form.append_collect_num": function formAppend_collect_num() {
      var _this4 = this;
      this.addDataList.forEach(function (item) {
        if (item.collect_num == _this4.form.append_collect_num) {
          _this4.form.append_views_num = item.views_num;
        }
      });
    },
    "form.url": function formUrl() {
      if (this.form.url) {
        this.form.imgs.push(this.form.url);
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/page", ["close"])), {}, {
    onCopy: function onCopy() {
      this.$message.success("复制成功");
    },
    onError: function onError() {
      this.$message.error("复制失败");
    },
    thumbnailUrl: function thumbnailUrl(url) {
      return url ? appendUrlParam(url, 'imageView2/0/w/400/h/400') : '';
    },
    closeRotateDialog: function closeRotateDialog() {
      this.imageRotateDialogVisible = false;
    },
    saveRotateImgUrl: function saveRotateImgUrl(url) {
      this.form.imgs.splice(this.imageRotateKey, 1, url);
      if (this.imageRotateUrl == this.form.cover) {
        this.form.cover = url;
      }
    },
    selectRotateImg: function selectRotateImg(key) {
      this.imageRotateKey = key || 0;
      this.imageRotateUrl = this.form.imgs[this.imageRotateKey];
      this.imageRotateDialogVisible = true;
    },
    keydownEventHandle: function keydownEventHandle(event) {
      if (event.key === 'ArrowLeft') {
        this.$refs.carousel.prev();
      }
      if (event.key === 'ArrowRight') {
        this.$refs.carousel.next();
      }
    },
    previewImage: function previewImage(index) {
      var _this5 = this;
      this.previewDialogVisible = true;
      this.$nextTick(function () {
        setTimeout(function () {
          _this5.$refs.carousel.setActiveItem(index);
        });
      });
    },
    getUserDeviceRisk: function getUserDeviceRisk() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this6.$api.getUserDeviceRisk({
                user_id: _this6.form.user_id
              });
            case 1:
              res = _context2.v;
              _this6.deviceRisk = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getUsersTagList: function getUsersTagList() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this7.$api.getUsersTagList({
                top: 5,
                user_id: _this7.form.user_id
              });
            case 1:
              res = _context3.v;
              if (res.data[_this7.form.user_id]) {
                _this7.userTag = res.data[_this7.form.user_id];
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    // 审核
    audit: function audit(status) {
      var _this8 = this;
      this.$confirm("是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this8.save('audit');
            case 1:
              _context4.n = 2;
              return _this8.$api.auditLifestyle({
                id: _this8.$route.query.id,
                status: status
              });
            case 2:
              _this8.$message.success("操作成功");

              // 操作上报
              _this8.$operationLog.push({
                code: status == 1 ? 'pass' : 'reject',
                userId: _this8.userForm.id,
                operationType: "lifestyle",
                detailBatchNo: _this8.$route.query.id
              });
              _this8.btnNextVisible = true;
              // if (status == 2) {
              //     this.$router.back();
              // }
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }))).catch(function () {});
    },
    // 推荐|取消推荐
    recommend: function recommend() {
      var _this9 = this;
      this.$confirm("是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this9.$api.recommendLifestyle({
                id: _this9.$route.query.id,
                type: _this9.form.is_recommend == 1 ? 0 : 1
              });
            case 1:
              _this9.getData();
              _this9.$message.success("操作成功");

              // 操作上报
              _this9.$operationLog.push({
                code: _this9.form.is_recommend == 1 ? 'unrecommend' : 'recommend',
                userId: _this9.userForm.id,
                operationType: "lifestyle",
                detailBatchNo: _this9.$route.query.id
              });
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))).catch(function () {});
    },
    saveUserInfo: function saveUserInfo() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this0.$api.updateUser({
                userId: _this0.userForm.id,
                update: {
                  avatar: _this0.userForm.avatar,
                  name: _this0.userForm.name,
                  remark: _this0.userForm.remark
                }
              });
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    getUserInfo: function getUserInfo(id) {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return _this1.$api.getUserBaseInfo({
                id: id
              });
            case 1:
              res = _context7.v;
              _this1.userForm = res.data;
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    getLifestyleTagList: function getLifestyleTagList() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return _this10.$api.getLifestyleTagListPython();
            case 1:
              res = _context8.v;
              _this10.tagList = res.data;
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    selectTag: function selectTag(name) {
      this.form.content += " #".concat(name);
    },
    getData: function getData() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var res;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return _this11.$api.getLifestyleInfo({
                id: _this11.$route.query.id
              });
            case 1:
              res = _context9.v;
              _this11.getUserInfo(res.data.user_id);
              res.data.tag = res.data.tag_ids || [];
              res.data.video = res.data.video.video;
              res.data.cover = res.data.cover.cover;
              res.data.create_at = dayjs(res.data.create * 1000).format("YYYY-MM-DD HH:mm:ss");
              _this11.form = res.data;
              _this11.getUsersTagList();
              _this11.getUserDeviceRisk();
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    tagMatch: function tagMatch(s) {
      var reg = /#.*? |#.*/g;
      s = s.match(reg);
      return s;
    },
    save: function save(type) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var tags;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _this12.saveUserInfo();
              tags = _this12.tagMatch(_this12.form.content) || [];
              tags.forEach(function (item, index) {
                tags[index] = item.replace("#", "").trim();
              });
              _this12.form.tags = tags;
              if (_this12.form.append_views_num) {
                _this12.form.append_views_num = parseInt(_this12.form.append_views_num);
              }
              if (_this12.form.append_collect_num) {
                _this12.form.append_collect_num = parseInt(_this12.form.append_collect_num);
              }
              _context0.n = 1;
              return _this12.$api.updateLifestyle(_this12.form);
            case 1:
              _this12.$message.success("保存成功");
              if (type != 'audit') {
                // 操作上报
                _this12.$operationLog.push({
                  code: 'save',
                  userId: _this12.userForm.id,
                  operationType: "lifestyle",
                  detailBatchNo: _this12.$route.query.id
                });
              }
            case 2:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    setCover: function setCover(url) {
      this.form.cover = url;
      // this.form.cover_type = 'image';
    },
    deleteImage: function deleteImage(index, img) {
      var _this13 = this;
      this.form.imgs.splice(index, 1);
      if (img == this.form.cover) {
        this.$nextTick(function () {
          _this13.form.cover = _this13.form.imgs[0];
        });
      }
    },
    deleteVideo: function deleteVideo() {
      this.form.video = "";
      this.form.cover = this.form.imgs[0];
    },
    selectVideoPreview: function selectVideoPreview() {
      var video = document.getElementById("J_video");
      var currentTime = Math.round(video.currentTime);
      this.form.cover = appendUrlParam(this.form.video, "vframe/jpg/offset/".concat(currentTime));
      this.form.video_cut_start_frame = currentTime;
      this.videoVisible = false;
    }
  })
};